import { render } from "./Rules.vue?vue&type=template&id=2f7e88ba&scoped=true"
const script = {}

import "./Rules.vue?vue&type=style&index=0&id=2f7e88ba&lang=scss&scoped=true"

import exportComponent from "/vercel/path3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7e88ba"]])

export default __exports__